export interface FileUploadStatus {
  success: boolean;
  message: string;
  fileName: string;
}

export interface DirectoryItem {
  fileName: string;
  absolutePath: string;
  directory: boolean;
  fileSize: number;
}

export interface Identifiable {
  id: string;
}

export enum EntityType {
  TYPE_DATA,
  TYPE_STYLE,
  TYPE_PRODUCT,
  TYPE_SERVICE,
  TYPE_FILE_INFO,
}

export interface MetadataModel {
  title: string;
  abstractText?: string;
  keywords?: string[];
}

export interface EntityModel extends Identifiable, MetadataModel {
  name?: string;
  sequenceNumber?: number;
}

export interface SpatialModel extends EntityModel {
  wgs84Bounds?: Bounds;
}

export interface Bounds {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface MappEntConfigurationInfo {
  securityInfo: {
    isMappEnterprise: boolean;
    mappEnterpriseSecurityInfo: {
      authServiceUrl: string;
      clientId: string;
    };
  };
  missingMappEnterpriseInfo: boolean;
  invalidMappEnterpriseInfo: boolean;
}

export interface ServerConfiguration {
  actuators: BasePath;
  wms: BasePath,
  studio: {
    webApp: BasePath;
    restApi: BasePath;
    internalApi: BasePath;
    login: BasePath;
    logout: BasePath;
    notifications: BasePath;
    dataPreviewPrefix: string;
    stylePreviewPrefix: string;
    productPreviewPrefix: string;
    previewBackgroundDataName: string;
  };
}

export interface BasePath {
  basePath: string;
}
